import React, { useState } from 'react'

import { Header } from '../../components/Header'
import { BannerRegisterSitter } from '../../components/BannerRegisterSitter'
import { SidebarFilter } from '../../components/SidebarFilter'
import { ListItems } from '../../components/ListItems'
import { GridItems } from '../../components/GridItems'
import { Footer } from '../../components/Footer'
export const List = () => {
    const [viewType, setViewType] = useState('list');

    const items = [
        {
            defaultImagePath: "images/listing-item-01.jpg",
            tag: "Eat & Drink",
            showNowOpen: true,
            showNowClosed: false,
            title: "Tom's Restaurant",
            verified: true,
            address: "964 School Street, New York",
            rating: "3.5",
            reviews: 12,
            isFavorite: true
        },
        {
            defaultImagePath: "images/listing-item-02.jpg",
            tag: "Events",
            showNowOpen: false,
            showNowClosed: false,
            title: "Sticky Band",
            verified: false,
            address: "Bishop Avenue, New York",
            rating: "5.0",
            reviews: 23,
            isFavorite: true
        },
        {
            defaultImagePath: "images/listing-item-01.jpg",
            tag: "Eat & Drink",
            showNowOpen: true,
            showNowClosed: false,
            title: "Tom's Restaurant",
            verified: true,
            address: "964 School Street, New York",
            rating: "3.5",
            reviews: 12,
            isFavorite: false
        },
        {
            defaultImagePath: "images/listing-item-02.jpg",
            tag: "Events",
            showNowOpen: false,
            showNowClosed: false,
            title: "Sticky Band",
            verified: false,
            address: "Bishop Avenue, New York",
            rating: "5.0",
            reviews: 23,
            isFavorite: false
        }
    ];
    return (
        <>
            <Header />
            {/* <!-- Titlebar=== --> */}
            <div id="titlebar" className="gradient">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <h2>Listado</h2>

                            {/* <!-- Breadcrumbs --> */}
                            <nav id="breadcrumbs">
                                <ul>
                                    <li><a href="/">Home</a></li>
                                    <li>Listado</li>
                                </ul>
                            </nav>

                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Content
================================================== --> */}
            <div className="container">
                <div className="row">

                    <div className="col-lg-9 col-md-8 padding-right-30">

                        {/* <!-- Sorting / Layout Switcher --> */}
                        <div className="row margin-bottom-25">

                            <div className="col-md-6 col-xs-6">
                                {/* <!-- Layout Switcher --> */}
                                <div className="layout-switcher">
                                    <a className={`grid ${viewType == 'grid' ? 'active' : ''}`} onClick={() => setViewType('grid')}><i className="fa fa-th"></i></a>
                                    <a className={`list ${viewType == 'list' ? 'active' : ''}`} onClick={() => setViewType('list')}><i className="fa fa-align-justify"></i></a>
                                </div>
                            </div>

                            <div className="col-md-6 col-xs-6">
                                {/* <!-- Sort by --> */}
                                <div className="sort-by">
                                    <div className="sort-by-select">
                                        <select data-placeholder="Default order" className="chosen-select-no-single">
                                            <option>Default Order</option>
                                            <option>Highest Rated</option>
                                            <option>Most Reviewed</option>
                                            <option>Newest Listings</option>
                                            <option>Oldest Listings</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {viewType == 'list' ? (
                            <ListItems items={items} />
                        ) : (
                            <GridItems items={items} />
                        )}
                    </div>
                    <SidebarFilter />
                </div>
            </div>
            <Footer />
        </>
    )
}